import {Provinces} from "@app/constants/Provinces";

export const CANDIDATE_FILES = {
    // Personal
    last_name: {name: 'Họ'},
    mid_name: {name: 'Tên đệm'},
    vn_name: {name: 'Tên VN'},
    full_name: {name: 'Họ & tên'},
    foreign_name: {name: 'Tên nước ngoài'},
    other_first_name: {name: 'Biệt danh'},
    email_name: {name: 'Tên (Email)'},
    gender: {name: 'Giới tính'},
    paper_dob: {name: 'Ngày sinh nhật (giấy tờ)'},
    vocative: {name: 'Xưng hô'},
    caller_name_to_email: {name: 'Gọi UV là (Email)'},
    marital_status: {name: 'Trạng thái hôn nhân'},
    martial_note: {name: 'Hôn nhân (Note)'},
    appearence: {name: 'Ngoại hình'},
    personal_note: {name: 'Note TT cá nhân'},

    // Location
    local_nationality: {name: 'Quốc tịch'},
    local_ever_work_nationality: {name: 'Nước ngoài từng làm việc'},
    local_address: {name: 'Địa chỉ'},
    local_province: {name: 'Local tỉnh'},
    local_area: {name: 'Vùng miền'},
    local_province_email: {name: 'Local tỉnh (Email)'},
    local_area_email: {name: 'Vùng miền (Email)'},
    local_note: {name: 'Note Local'},

    // Contacts
    phone: {name: 'Số ĐT'},
    home_phone: {name: 'Số ĐT nhà'},
    rarely_phone: {name: 'Số ĐT ít dùng'},
    ever_phone: {name: 'Số ĐT từng dùng'},
    email: {name: 'Email'},
    email_to_send: {name: 'Email to send'},
    rarely_email: {name: 'Email ít dùng'},
    ever_email: {name: 'Email từng dùng/lỗi'},
    block_email: {name: 'Email bị khoá'},
    skype: {name: 'Skype'},
    whats_app: {name: 'Whats app'},
    lines: {name: 'Lines'},
    facebook: {name: 'Facebook'},
    linkedin: {name: 'Linkedin'},
    vnw: {name: 'VNW'},
    cb: {name: 'CB'},
    js: {name: 'JS'},
    topcv: {name: 'TopCV'},
    other: {name: 'Other'},
    deleted_contact: {name: 'Contacts đã xoá'},
}
